import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { supabase } from "../../supabaseClient";

import FSNavigation from "../FSApp/FSNavigation";
import HomeFooter from "../HomePage/HomeFooter";

import FucaScoreLogo from "../../Assets/Images/fucascore_png.png";
import { Turnstile } from "@marsidev/react-turnstile";

/* =========================================
   FS APP
========================================= */

import FSLive from "../../Assets/FucaScoreApp/FSLive.png";
import FSRaspored from "../../Assets/FucaScoreApp/FSRaspored.png";
import FSRezultati from "../../Assets/FucaScoreApp/FSRezultati.png";
import FSGroups from "../../Assets/FucaScoreApp/FSGroups.png";
import FSZavrsnica from "../../Assets/FucaScoreApp/FSZavrsnica.png";
import FSStrijelci from "../../Assets/FucaScoreApp/FSStrijelci.png";
import FSRewards from "../../Assets/FucaScoreApp/FSRewards.png";
import FSNav from "../../Assets/FucaScoreApp/FSNavigation.png";

/* =========================================
   FS ADMIN
========================================= */

import FSAdminLive from "../../Assets/FucaScoreApp/FSAdminLive.png";
import FSAdminLiveAdd from "../../Assets/FucaScoreApp/FSAdminLiveAdd.png";
import FSAdminResults from "../../Assets/FucaScoreApp/FSAdminResults.png";
import FSAdminRaspored from "../../Assets/FucaScoreApp/FSAdminRaspored.png";
import FSAdminGroups from "../../Assets/FucaScoreApp/FSAdminGroups.png";
import FSAdminZavrsnica from "../../Assets/FucaScoreApp/FSAdminZavrsnica.png";
import FSAdminSettings from "../../Assets/FucaScoreApp/FSAdminSettings.png";

export default function FSPokreniTurnir() {
  const [activeTab, setActiveTab] = useState("app");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [formData, setFormData] = useState({
    email: "",
    turnirNaziv: "",
    datumOd: "",
    datumDo: "",
    poruka: "",
  });
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight * 1.5) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Funkcija za skrolanje na vrh:
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const appSlides = [
    {
      image: FSLive,
      title: "Turnir uživo",
      description:
        "Prikažite utakmicu uživo uz rezultate, golove i događaje koji se ažuriraju u stvarnom vremenu.",
    },
    {
      image: FSRezultati,
      title: "Svi rezultati na jednom mjestu",
      description:
        "Gledatelji mogu u svakom trenutku provjeriti rezultate svih odigranih utakmica.",
    },
    {
      image: FSRaspored,
      title: "Raspored po danima",
      description:
        "Kompletan raspored utakmica s vremenima, terenima i svim važnim informacijama.",
    },
    {
      image: FSGroups,
      title: "Grupe i tablice",
      description:
        "Automatski pregled bodova, gol-razlike, plasmana i stanja u skupinama.",
    },
    {
      image: FSZavrsnica,
      title: "Završnica turnira",
      description:
        "Jasno prikazana nokaut faza, četvrtfinale, polufinale i veliko finale.",
    },
    {
      image: FSStrijelci,
      title: "Strijelci i statistika",
      description:
        "Pratite najbolje strijelce turnira i individualnu statistiku igrača.",
    },
    {
      image: FSRewards,
      title: "Nagrade i priznanja",
      description:
        "Prikažite nagradni fond, priznanja i najbolje pojedince vašeg turnira.",
    },
    {
      image: FSNav,
      title: "Sve informacije na jednom mjestu",
      description:
        "Brza navigacija do rezultata, završnice, strijelaca, događaja, sponzora i dodatnog sadržaja.",
    },
  ];

  /* =========================================
     ADMIN SLIDES
  ========================================= */

  const adminSlides = [
    {
      image: FSAdminLive,
      title: "Jednostavan Live",
      description:
        "Pokrenite utakmicu i unosite golove, kartone i ostale događaje izravno s mobitela.",
    },
    {
      image: FSAdminLiveAdd,
      title: "Unos događaja u nekoliko klikova",
      description:
        "Sučelje je prilagođeno brzom radu tijekom utakmice kako biste mogli pratiti događaje bez kompliciranja.",
    },
    {
      image: FSAdminResults,
      title: "Potpuna kontrola rezultata",
      description:
        "Ako je potrebna promjena, rezultat, strijelca ili događaj možete jednostavno urediti.",
    },
    {
      image: FSAdminRaspored,
      title: "Organizacija rasporeda",
      description:
        "Složite kompletnu satnicu turnira i jednostavno upravljajte terminima utakmica.",
    },
    {
      image: FSAdminGroups,
      title: "Upravljanje grupama",
      description:
        "Dodajte ekipe, rasporedite ih po skupinama i pratite stanje tablica.",
    },
    {
      image: FSAdminZavrsnica,
      title: "Jednostavna završnica",
      description:
        "Organizirajte nokaut fazu i pratite prolazak ekipa sve do finala.",
    },
    {
      image: FSAdminSettings,
      title: "Sve pod vašom kontrolom",
      description:
        "Upravljajte postavkama turnira, sponzorima, vizualima i administratorskim mogućnostima.",
    },
  ];

  const currentSlides = activeTab === "app" ? appSlides : adminSlides;

  /* =========================================
     SLIDER
  ========================================= */

  const handlePrevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? currentSlides.length - 1 : prev - 1,
    );
  };

  const handleNextSlide = () => {
    setCurrentIndex((prev) =>
      prev === currentSlides.length - 1 ? 0 : prev + 1,
    );
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentIndex(0);
  };

  /* =========================================
     FORM
  ========================================= */

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!turnstileToken) {
      alert("Molimo potvrdite da niste bot.");
      return;
    }

    try {
      const { error } = await supabase.functions.invoke("send-inquiry", {
        body: {
          turnirNaziv: formData.turnirNaziv,
          email: formData.email,
          datumOd: formData.datumOd,
          datumDo: formData.datumDo,
          poruka: formData.poruka,
          turnstileToken: turnstileToken,
        },
      });

      if (error) throw error;

      setFormSubmitted(true);
    } catch (error) {
      console.error("Greška pri slanju upita:", error.message || error);

      alert("Došlo je do greške pri slanju poruke. Molimo pokušajte ponovno.");
    }
  };

  return (
    <>
      <FSNavigation />

      <main className="pokreni-turnir-container">
        <section className="pokreni-hero-section">
          <div className="pokreni-hero-badge">
            <i className="fa-solid fa-trophy"></i>

            <span>DIGITALNA PLATFORMA ZA TURNIRE</span>
          </div>

          <img
            src={FucaScoreLogo}
            alt="FucaScore"
            className="pokreni-hero-logo"
          />

          <h1>
            Vaš turnir.
            <br />
            <span>Vaša digitalna platforma.</span>
          </h1>

          <p>
            FucaScore vašem turniru daje modernu web aplikaciju u kojoj igrači i
            gledatelji mogu pratiti sve — od rasporeda i rezultata do Live
            utakmica, strijelaca i završnice.
          </p>

          <div className="pokreni-hero-url">
            <i className="fi fi-br-link-alt"></i>

            <span>Vlastita stranica turnira</span>

            <strong>fucascore.com/vas-turnir</strong>
          </div>

          <div className="pokreni-hero-actions">
            <button
              type="button"
              className="hero-main-btn"
              onClick={() => {
                document
                  .querySelector(".form-section-wrapper")
                  ?.scrollIntoView({
                    behavior: "smooth",
                  });
              }}
            >
              <i className="fa-solid fa-rocket"></i>
              Želim FucaScore
            </button>

            <button
              type="button"
              className="hero-secondary-btn"
              onClick={() => {
                document.querySelector(".slider-section")?.scrollIntoView({
                  behavior: "smooth",
                });
              }}
            >
              <i className="fa-solid fa-eye"></i>
              Pogledajte kako izgleda
            </button>
          </div>
        </section>

        {/* =========================================
            BENEFITS
        ========================================= */}

        <section className="pokreni-benefits-section">
          <div className="benefit-box">
            <div className="benefit-box-icon">
              <i className="fa-solid fi-rr-devices"></i>
            </div>

            <div>
              <h3>Vlastita stranica turnira</h3>

              <p>
                Jedan link koji možete poslati ekipama, igračima i gledateljima.
              </p>
            </div>
          </div>

          <div className="benefit-box">
            <div className="benefit-box-icon">
              <i className="fa-solid fi-rr-live-alt"></i>
            </div>

            <div>
              <h3>Sve u stvarnom vremenu</h3>

              <p>
                Rezultati, događaji, tablice i statistike dostupni su odmah.
              </p>
            </div>
          </div>

          <div className="benefit-box">
            <div className="benefit-box-icon">
              <i className="fa-solid fi-rr-settings-sliders"></i>
            </div>

            <div>
              <h3>Vi upravljate turnirom</h3>

              <p>
                Jednostavan Admin omogućuje vam potpunu kontrolu nad sadržajem.
              </p>
            </div>
          </div>
        </section>

        <section className="pokreni-header-section">
          <div className="section-small-label">FUCASCORE EXPERIENCE</div>

          <h2>Sve što vaš turnir treba.</h2>

          <p>
            Od prve utakmice do finala — sve informacije vašeg turnira dostupne
            su na jednom mjestu.
          </p>
        </section>

        {/* =========================================
            APP / ADMIN TABS
        ========================================= */}

        <div className="home-navigation">
          <button
            type="button"
            className={activeTab === "app" ? "active" : ""}
            onClick={() => handleTabChange("app")}
          >
            <i className="fa-solid fa-mobile-screen"></i>
            Aplikacija
          </button>

          <button
            type="button"
            className={activeTab === "admin" ? "active" : ""}
            onClick={() => handleTabChange("admin")}
          >
            <i className="fa-solid fa-user-gear"></i>
            Admin
          </button>
        </div>

        <section className="slider-section">
          <div className="slider-wrapper-box">
            <button
              type="button"
              className="arrow-btn left"
              onClick={handlePrevSlide}
              aria-label="Prethodna slika"
            >
              &#10094;
            </button>

            <div className="slide-content">
              <div className="mockup-container">
                <img
                  src={currentSlides[currentIndex].image}
                  alt={currentSlides[currentIndex].title}
                />
              </div>
            </div>

            <button
              type="button"
              className="arrow-btn right"
              onClick={handleNextSlide}
              aria-label="Sljedeća slika"
            >
              &#10095;
            </button>
          </div>

          {/* DOTS */}

          <div className="dots-container">
            {currentSlides.map((_, index) => (
              <button
                type="button"
                key={index}
                className={`dot ${currentIndex === index ? "active" : ""}`}
                onClick={() => setCurrentIndex(index)}
                aria-label={`Prikaži slajd ${index + 1}`}
              />
            ))}
          </div>

          {/* SLIDE INFO */}

          <motion.div
            className="slide-info-text"
            key={`${activeTab}-${currentIndex}`}
            initial={{
              opacity: 0,
              y: 8,
            }}
            animate={{
              opacity: 1,
              y: 0,
            }}
            transition={{
              duration: 0.25,
            }}
          >
            <span className="slide-number">
              {String(currentIndex + 1).padStart(2, "0")}
              {" / "}
              {String(currentSlides.length).padStart(2, "0")}
            </span>

            <h3>{currentSlides[currentIndex].title}</h3>

            <p>{currentSlides[currentIndex].description}</p>
          </motion.div>
        </section>

        {/* =========================================
            DIFFERENCE
        ========================================= */}

        <section className="pokreni-difference-section">
          <div className="difference-heading">
            <div className="section-small-label">ZAŠTO FUCASCORE?</div>

            <h2>
              Vi organizirate turnir.
              <br />
              <span>FucaScore ga digitalizira.</span>
            </h2>

            <p>
              Ne morate se baviti izradom stranice, tablica ili kompliciranih
              sustava. Vi vodite natjecanje, a FucaScore vam daje alat za
              njegovo moderno predstavljanje.
            </p>
          </div>

          <div className="difference-grid">
            <div className="difference-item">
              <i className="fi fi-br-link-alt"></i>

              <div>
                <h3>Vlastiti link turnira</h3>

                <p>
                  Vaš turnir dobiva svoju stranicu koju možete dijeliti gdje god
                  želite.
                </p>
              </div>
            </div>

            <div className="difference-item">
              <i className="fi fi-rr-score-board"></i>

              <div>
                <h3>Digitalni semafor</h3>

                <p>
                  Prikažite rezultat utakmice uživo na velikom ekranu tijekom
                  turnira.
                </p>
              </div>
            </div>

            <div className="difference-item">
              <i className="fi fi-rr-ranking-star"></i>

              <div>
                <h3>Najbolji igrači turnira</h3>

                <p>
                  Istaknite najbolje strijelce, igrače i nagrade na kraju
                  turnira.
                </p>
              </div>
            </div>

            <div className="difference-item">
              <i className="fi fi-rr-briefcase"></i>

              <div>
                <h3>Više prostora za sponzore</h3>

                <p>
                  Predstavite sponzore turnira i povežite ih direktno s njihovim
                  stranicama.
                </p>
              </div>
            </div>

            <div className="difference-item">
              <i className="fi fi-rr-basketball"></i>

              <div>
                <h3>Više od nogometa</h3>

                <p>
                  Turniri u futsalu, veteranima, beli, košarci i drugim
                  natjecanjima.
                </p>
              </div>
            </div>

            <div className="difference-item">
              <i className="fi fi-rr-share"></i>

              <div>
                <h3>Sadržaj spreman za dijeljenje</h3>

                <p>
                  Najbolje igrače, rezultate i sadržaj možete lako predstaviti
                  na društvenim mrežama.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/*    <section className="pokreni-price-section">
          <div className="price-badge">JEDNOSTAVNO I BEZ PRETPLATE</div>

          <h2>Vaš turnir za</h2>

          <div className="big-price">79 €</div>

          <p>
            Jednokratna cijena za jedan turnir.
            <br />
            Bez mjesečne pretplate i bez dugoročnog ugovora.
          </p>

          <div className="price-checks">
            <span>
              <i className="fa-solid fa-check"></i>
              Vlastita stranica turnira
            </span>

            <span>
              <i className="fa-solid fa-check"></i>
              Live rezultati
            </span>

            <span>
              <i className="fa-solid fa-check"></i>
              Admin sustav
            </span>

            <span>
              <i className="fa-solid fa-check"></i>
              Statistike i rasporedi
            </span>
          </div>
        </section> */}

        <section className="form-section-wrapper">
          {!formSubmitted ? (
            <form className="turnir-form" onSubmit={handleSubmit}>
              <div className="form-heading">
                <div className="section-small-label">KRENIMO</div>

                <h2>Želite FucaScore za svoj turnir?</h2>

                <p>
                  Pošaljite nam osnovne informacije i javit ćemo vam se s
                  detaljima.
                </p>
              </div>

              <div className="form-group">
                <input
                  type="text"
                  name="turnirNaziv"
                  placeholder="Naziv turnira"
                  value={formData.turnirNaziv}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Vaša email adresa"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Od kada se održava:</label>

                  <input
                    type="date"
                    name="datumOd"
                    value={formData.datumOd}
                    onChange={handleInputChange}
                    min={new Date().toISOString().split("T")[0]}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Do kada se održava:</label>

                  <input
                    type="date"
                    name="datumDo"
                    value={formData.datumDo}
                    onChange={handleInputChange}
                    min={
                      formData.datumOd || new Date().toISOString().split("T")[0]
                    }
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <textarea
                  name="poruka"
                  placeholder="Poruka ili dodatne informacije (opcionalno)..."
                  rows="5"
                  value={formData.poruka}
                  onChange={handleInputChange}
                />
              </div>

              <div className="turnstile-wrapper">
                <Turnstile
                  siteKey="0x4AAAAAAD-bRw2DrEn7ycda"
                  theme="dark"
                  options={{
                    theme: "dark",
                  }}
                  onSuccess={(token) => setTurnstileToken(token)}
                  onExpire={() => setTurnstileToken(null)}
                />
              </div>

              <button type="submit" className="submit-btn">
                <i className="fa-solid fa-paper-plane"></i>
                Pošalji upit
              </button>

              {/*        <div className="form-trust">
                <span>
                  <i className="fa-solid fa-shield-halved"></i>
                  Bez obveze
                </span>

                <span>
                  <i className="fa-solid fa-bolt"></i>
                  Brz odgovor
                </span>

                <span>
                  <i className="fa-solid fa-check"></i>
                  Bez pretplate
                </span>
              </div> */}
            </form>
          ) : (
            <motion.div
              className="success-message-box"
              initial={{
                opacity: 0,
                scale: 0.9,
              }}
              animate={{
                opacity: 1,
                scale: 1,
              }}
              transition={{
                duration: 0.4,
              }}
            >
              <img
                src={FucaScoreLogo}
                alt="FucaScore Logo"
                className="success-logo"
              />

              <h3>Vaša poruka je uspješno poslana!</h3>

              <p>
                {/*  Hvala na interesu za FucaScore.
                <br /> */}
                Javit ćemo vam se u najbržem roku.
              </p>
            </motion.div>
          )}
        </section>
      </main>

      <HomeFooter />
      {showScrollTop && (
        <button
          type="button"
          className="scroll-to-top-btn"
          onClick={scrollToTop}
          aria-label="Povratak na vrh"
        >
          <i className="fi fi-br-angle-small-up"></i>
        </button>
      )}
    </>
  );
}
